import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './edit-question-modal.style';

export class EditQuestionModal extends Component {

  render() {
    const { show, onCancel, onSave, title, subtitle, label, tooltip, css, contentId, modalId, onLabelChange, onTooltipChange } = this.props;

    return(
      <div tabIndex={-1} id={modalId || "modal"}>
        <div className={show ? css.show : css.hide}>
          <div className={css.dialog}>
            <div className={css.content}>
              <div className={css.header}>
                <button type="button" className={css.closeButton} onClick={e => onCancel()}>
                  <span aria-label="close">&times;</span>
                </button>
                <h3 className={css.title}>
                  <b>{title}</b>
                </h3>
                <h5 className={css.subtitle}>
                  {subtitle}
                </h5>
              </div>
              <div tabIndex={-1} id={contentId || "modal-content"} className={css.body + " no-focus"}>
                <form className="form-horizontal narrow">
                  <div className="form-group">
                    <label className={"col-sm-2 " + css.label}>Label</label>
                    <div className="col-sm-9">
                      <input className="form-control" type="text" value={label || ""} id={"labelText"} maxLength="100" onChange={e => onLabelChange(e.target.value)}/>
                    </div>
                  </div>
                  <div className="form-group">
                    <label className={"col-sm-2 " + css.label}>Tooltip</label>
                    <div className="col-sm-9">
                      <textarea
                        id={"tooltip"}
                        maxLength={500}
                        rows={3}
                        onChange={e => onTooltipChange(e.target.value)}
                        value={tooltip || ""}
                        className={"form-control"}
                        aria-required={false} />
                    </div>
                  </div>
                </form>
              </div>
              <div className={css.footer}>
                <div>
                  <button
                    id='confirm'
                    className='btn btn-primary'
                    onClick={e => {
                      onSave(label, tooltip);
                    }}>
                    OK
                  </button>
                  <button
                    id='cancel'
                    className='btn btn-default'
                    onClick={e => onCancel()}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={show ? css.backgroundShow : css.backgroundHide} />
      </div>
    );
  }
}

EditQuestionModal.propTypes = {
  modalId: PropTypes.string,
  contentId: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onLabelChange: PropTypes.func.isRequired,
  onTooltipChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  footer: PropTypes.element,
  label: PropTypes.string,
  tooltip: PropTypes.string,
};

export default styleable(defaultStyle)(EditQuestionModal);
